export const UAD_TO_PERCENT: Record<string, number> = {
  '1.0': 0,
  '1.1': 0,
  '1.2': 0,
  '1.3': 0,
  '1.4': 0,
  '1.5': 1.67,
  '1.6': 1.67,
  '1.7': 3.33,
  '1.8': 5,
  '1.9': 6.67,
  '2.0': 8.33,
  '2.1': 10,
  '2.2': 11.67,
  '2.3': 13.33,
  '2.4': 15,
  '2.5': 16.67,
  '2.6': 18.33,
  '2.7': 20,
  '2.8': 21.67,
  '2.9': 23.33,
  '3.0': 25,
  '3.1': 26.67,
  '3.2': 28.33,
  '3.3': 30,
  '3.4': 31.67,
  '3.5': 33.33,
  '3.6': 35,
  '3.7': 36.67,
  '3.8': 38.33,
  '3.9': 40,
  '4.0': 41.67,
  '4.1': 43.33,
  '4.2': 45,
  '4.3': 46.67,
  '4.4': 48.33,
  '4.5': 50,
  '4.6': 53.33,
  '4.7': 56.67,
  '4.8': 60,
  '4.9': 63.33,
  '5.0': 66.67,
  '5.1': 70,
  '5.2': 73.33,
  '5.3': 76.67,
  '5.4': 80,
  '5.5': 83.33,
  '5.6': 86.67,
  '5.7': 90,
  '5.8': 93.33,
  '5.9': 96.67,
  '6.0': 100,
};
